import React, { useEffect, useRef, useContext, Fragment } from 'react';
import { Observer } from 'mobx-react-lite';
import FadeIn from 'react-fade-in';
import { toast } from 'react-toastify';

import CommunicationTemplateCreateStore from '../../../../../../stores/CommunicationTemplateCreateStore';

import QuickDrawerHeader from '../../../../_shared/QuickDrawerHeader';

import * as ErrorMessages from '../../../../../../constants/errorMessages';
import * as ch from '../../../../../../utilities/communicationTemplateHelper';
import * as fn from '../../../../../../utilities/_functions';

import './NewCommunicationTemplate.scss';

function NewCommunicationTemplate(props) {
    const isMounted = useRef(true);
    const validateRef = useRef(null);
    const communicationTemplate = useContext(CommunicationTemplateCreateStore);

    useEffect(() => {
        return (() => {
            isMounted.current = false;
        })
    }, []) // eslint-disable-line

    const handleCancel = () => {
        if (fn.isFunction(props.onCancel)) {
            if (communicationTemplate.hasUnsavedChanges) {
                if (window.confirm(ErrorMessages.DISCARD_CHANGES)) {
                    props.onCancel();
                }
            } else {
                props.onCancel();
            }
        }
    }

    const handleNameChange = (event) => {
        const { value } = event.target;
        communicationTemplate.data.name = value;
        communicationTemplate.hasUnsavedChanges = true;
    }

    const handleTemplateTypeChange = (event) => {
        const { value } = event.target;
        communicationTemplate.data.templateType = value;
        communicationTemplate.hasUnsavedChanges = true;
    }

    const handleCommunicationTypeChange = (event) => {
        const { value } = event.target;
        const index = communicationTemplate.data.communicationTypes.findIndex(t => t === value);

        if (index >= 0) {
            communicationTemplate.data.communicationTypes.splice(index, 1);
        }
        else {
            communicationTemplate.data.communicationTypes.push(value);
        }

        communicationTemplate.hasUnsavedChanges = true;
    }

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isMounted.current) {
            if (fn.validateForm(validateRef.current)) {
                communicationTemplate.save()
                    .then((data) => {
                        if (props.onSuccess && fn.isFunction(props.onSuccess)) {
                            props.onSuccess(event, { data });
                        }

                        handleCancel(event);
                    })
                    .catch(({ response }) => {
                        let message = ErrorMessages.GENERIC_ERROR_HTML;

                        switch (response.status) {
                            case 409:
                                message = <p>Template already exists.</p>;
                                break;

                            default:
                                break;
                        }

                        toast.error(() => message, { position: 'top-center' });
                    });
            }
        }
    }

    return <>
        <form ref={validateRef} onSubmit={handleSubmit}>
            <fieldset>
                <div className='quick-drawer'>
                    <QuickDrawerHeader
                        drawer={props.drawer}
                        icon={'fal fa-code'}
                        action='New'
                        category={`Communication Template`}
                        onCancel={handleCancel}
                    />
                    <div className='quick-drawer-body'>
                        <Observer>{() => <>
                            {
                                communicationTemplate.isReady ?
                                    <FadeIn>
                                        <div className='new-communication-template body-content'>
                                            <section>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <h4 className='fw-500'>{ch.getSubTypeName(communicationTemplate.selectedSubType)} Template</h4>
                                                        <div className='mb-4'>{ch.getSubTypeDescription(communicationTemplate.selectedSubType)}</div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-4 validate validate-required'>
                                                            <label className='required'><small>Name</small></label>
                                                            <Observer>{() => <>
                                                                <input
                                                                    type='text'
                                                                    className='form-control'
                                                                    value={communicationTemplate.data.name ? communicationTemplate.data.name : ''}
                                                                    onChange={handleNameChange}
                                                                />
                                                            </>}</Observer>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-4 validate validate-required'>
                                                            <label className='required'><small>Select Template Type</small></label>
                                                            <Observer>{() => <>
                                                                {
                                                                    communicationTemplate.templateTypes && communicationTemplate.templateTypes.length > 0 ?
                                                                        <>
                                                                            {
                                                                                communicationTemplate.templateTypes.map((t, ti) => {
                                                                                    const key = `new-communication-template-type-${t.id}`;
                                                                                    const hasOtherTypeNames = communicationTemplate.templateTypes.some(tt => ch.getTypeName(tt.id) !== ch.getTypeName(t.id));
                                                                                    const services = ch.getDisplayBadges(t.id, 'p-h mr-1');

                                                                                    return <div
                                                                                        key={`new-communication-template-type-${ti}`}
                                                                                        className='custom-control custom-radio mb-2'
                                                                                    >
                                                                                        <input
                                                                                            id={key}
                                                                                            type='radio'
                                                                                            name='newCommunicationTemplateType'
                                                                                            value={t.id}
                                                                                            className='custom-control-input'
                                                                                            checked={communicationTemplate.data.templateType === t.id}
                                                                                            onChange={handleTemplateTypeChange}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={key}
                                                                                            className='custom-control-label'
                                                                                        >
                                                                                            {
                                                                                                hasOtherTypeNames ?
                                                                                                    <>
                                                                                                        <strong className='fs-md'>{ch.getTypeName(t.id)}</strong><br />
                                                                                                        {ch.getTypeSubTitle(t.id)}
                                                                                                    </> :
                                                                                                    <>
                                                                                                        <strong className='fs-md'>{ch.getTypeSubTitle(t.id)}</strong>
                                                                                                    </>
                                                                                            }
                                                                                            {
                                                                                                services && services.length > 0 ?
                                                                                                    <>
                                                                                                        <span className='d-flex align-items-center'>
                                                                                                            {
                                                                                                                services.map((b, bi) => {
                                                                                                                    return <Fragment key={`new-communication-template-type-${ti}-badge-${bi}`}>
                                                                                                                        {b}
                                                                                                                    </Fragment>
                                                                                                                })
                                                                                                            }
                                                                                                        </span>
                                                                                                    </> : null
                                                                                            }
                                                                                        </label>
                                                                                    </div>
                                                                                })
                                                                            }
                                                                        </> : null
                                                                }
                                                            </>}</Observer>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='row'>
                                                    <div className='col-12'>
                                                        <div className='form-group mb-4 validate validate-required'>
                                                            <label className='required'><small>Communication</small></label>
                                                            <div className='custom-control custom-checkbox mb-2'>
                                                                <input
                                                                    id='new-communication-template-email'
                                                                    type='checkbox'
                                                                    name='new-communication-template-communication'
                                                                    className='custom-control-input'
                                                                    value='Email'
                                                                    checked={communicationTemplate.data.communicationTypes.some(t => t === 'Email')}
                                                                    onChange={handleCommunicationTypeChange}
                                                                />
                                                                <label
                                                                    htmlFor='new-communication-template-email'
                                                                    className='custom-control-label'
                                                                >
                                                                    Email Template
                                                                </label>
                                                            </div>
                                                            <div className='custom-control custom-checkbox mb-2'>
                                                                <input
                                                                    id='new-communication-template-sms'
                                                                    type='checkbox'
                                                                    name='new-communication-template-communication'
                                                                    className='custom-control-input'
                                                                    value='SMS'
                                                                    checked={communicationTemplate.data.communicationTypes.some(t => t === 'SMS')}
                                                                    onChange={handleCommunicationTypeChange}
                                                                />
                                                                <label
                                                                    htmlFor='new-communication-template-sms'
                                                                    className='custom-control-label'
                                                                >
                                                                    SMS Template
                                                                </label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </section>
                                        </div>
                                    </FadeIn> : <></>
                            }
                        </>}</Observer>
                    </div>
                    <div className='quick-drawer-action'>
                        <div className='row'>
                            <div className='col-4'></div>
                            <div className='col-8'>
                                <div className='float-right'>
                                    <button
                                        type='button'
                                        className='btn btn-link btn-cancel mr-2'
                                        onClick={handleCancel}
                                    >Cancel</button>
                                    <button
                                        type='submit'
                                        className='btn btn-success'
                                    >Create</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </fieldset>
        </form>
    </>
}

export default NewCommunicationTemplate;